import { Loader2 } from 'lucide-react';

const Loading = ({ text }: { text: string }) => {
  return (
    <div className='rounded-xl border border-gray-100 bg-transparent p-8'>
      <div className='flex flex-col items-center justify-center space-y-6'>
        <div className='relative'>
          <div className='flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-blue-100 to-purple-100'>
            <Loader2 className='h-8 w-8 animate-spin text-blue-600' />
          </div>
          <div className='absolute -inset-2 animate-pulse rounded-full bg-gradient-to-r from-blue-200 to-purple-200 opacity-20'></div>
        </div>
        <div className='space-y-2 text-center'>
          <h3 className='text-lg font-semibold text-gray-900'>{text}</h3>
          <p className='text-sm text-gray-500'>
            Please wait while we fetch your data
          </p>
        </div>
        <div className='flex space-x-1'>
          <div className='h-2 w-2 animate-bounce rounded-full bg-blue-400'></div>
          <div
            className='h-2 w-2 animate-bounce rounded-full bg-blue-400'
            style={{ animationDelay: '0.1s' }}
          ></div>
          <div
            className='h-2 w-2 animate-bounce rounded-full bg-blue-400'
            style={{ animationDelay: '0.2s' }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
